import Vue from 'vue'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      components: [],
      componentsRegistered: false
    }
  },
  methods: {
    setSportComponents () {
      const { sport } = this
      const { scheme, components } = sport
      const { modules } = scheme
      const { info, eventLog, statistic } = modules
      const componentsTemp = []

      const modulesKeys = Object.keys(modules)

      this.setTraderBlocks(modulesKeys)

      this.registerCustomComponents(components)

      if (info) {
        componentsTemp.push(this.getInfoComponent(info))
      }

      modulesKeys.forEach(key => {
        if (
          ['info', 'eventLog', 'statistic'].includes(key) ||
          !modules.hasOwnProperty(key)
        ) return

        const module = { ...modules[key] }

        let { component } = module

        componentsTemp.push({
          component,
          type: key,
          props: module
        })
      })

      if (statistic) {
        componentsTemp.push(this.getStatisticComponent(statistic))
      }

      componentsTemp.push(this.getEventLogComponent(eventLog))

      this.components = componentsTemp

      this.componentsRegistered = true
    },
    getInfoComponent (info) {
      const infoComponent = {
        type: 'info',
        childComponents: []
      }

      info.forEach(item => {
        if (typeof item === 'string') {
          infoComponent.childComponents.push({
            type: item
            // component: `trader-card-info-${item}`
          })
        }

        const { type, props, component } = item

        infoComponent.childComponents.push({
          type,
          props,
          component
          // component: component || `trader-card-info-${type}`
        })
      })

      return infoComponent
    },
    getStatisticComponent (statistic) {
      const { additionalStatisticBlocks } = statistic
      const statisticTemp = []

      if (additionalStatisticBlocks) {
        additionalStatisticBlocks.forEach(({ type, component }) => {
          statisticTemp.push({
            type,
            component
          })
        })
      }

      return {
        type: 'statistic',
        childComponents: statisticTemp
      }
    },
    getEventLogComponent (eventLog) {
      if (!eventLog) return

      const { additionalPeriods } = eventLog
      const eventLogTemp = []

      if (additionalPeriods) {
        additionalPeriods.forEach(({ type, component, ...props }) => {
          eventLogTemp.push({
            type,
            component,
            props
          })
        })
      }

      return {
        type: 'eventLog',
        childComponents: eventLogTemp
      }
    },
    registerCustomComponents (components) {
      if (!components) return

      const keys = Object.keys(components)

      keys.forEach(key => {
        if (!components.hasOwnProperty(key)) return

        Vue.component(key, components[key])
      })
    }
  }
}
